import React from 'react';
import { formatPhoneDisplay } from '../shared/phoneFormat';

export default function JoinRequests({ requests, error, onAccept, onDecline, colors }) {
  const rows = requests || [];
  if (!rows.length && !error) return null;
  return (
    <section
      data-testid="agent-join-requests"
      style={{
        margin: '0 0 0.9rem',
        padding: '0.9rem',
        borderRadius: '14px',
        border: `1px solid ${colors.border}`,
        background: colors.surface,
        color: colors.text,
      }}
    >
      <h3 style={{ margin: '0 0 0.65rem', fontSize: '1rem' }}>Homeowner requests</h3>
      {error ? <p role="alert" style={{ margin: '0 0 0.65rem' }}>{error}</p> : null}
      {rows.map((row) => (
        <div key={row.id} style={{ padding: '0.35rem 0 0.75rem' }}>
          <p style={{ margin: 0, fontWeight: 700 }}>{row.name}</p>
          <p style={{ margin: '0.15rem 0', color: colors.textSecondary }}>{row.email}</p>
          {row.phone ? <p style={{ margin: '0.15rem 0 0.55rem', color: colors.textSecondary }}>{formatPhoneDisplay(row.phone)}</p> : null}
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button type="button" data-testid="agent-join-accept" onClick={() => onAccept && onAccept(row.id)} style={buttonStyle(true)}>Accept</button>
            <button type="button" data-testid="agent-join-decline" onClick={() => onDecline && onDecline(row.id)} style={buttonStyle(false, colors)}>Decline</button>
          </div>
        </div>
      ))}
    </section>
  );
}

function buttonStyle(filled, colors) {
  return {
    flex: '1 1 0',
    minHeight: '44px',
    borderRadius: '999px',
    border: filled ? 'none' : `1px solid ${(colors && colors.border) || '#cbd5e1'}`,
    background: filled ? '#59c4c4' : 'transparent',
    color: filled ? '#083838' : ((colors && colors.text) || '#0f172a'),
    fontWeight: 700,
    cursor: 'pointer',
  };
}
